import React from 'react';

const Compare = (props) => {
  return <div id="searchandfilter-index-compare">Compare</div>;
};

export default Compare;
